<template>
  <v-container fluid class="pt-3">
    <OrderCommerceTable :shop="shop" :showStat="true"></OrderCommerceTable>
  </v-container>
</template>
<script>
import OrderCommerceTable from "@/components/table/OrderCommerceTable";

export default {
  components: {
    OrderCommerceTable,
  },
  data() {
    return {
      shop: null,
    };
  },
  created() {},
};
</script>
